import {
  Box,
  CircularProgress,
  TextField,
  Typography,
  useTheme,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import _ from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { StateStatus } from 'redux/utils/common';
import { ITabContentProps, PropertyFilterType } from '../configuration';
import ProductFilterActions from '../store/actions';
import * as ProductFilterSelectors from '../store/selectors';

const TabZone = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const zoneList = ProductFilterSelectors.useGetZonesList();
  React.useEffect(() => {
    if (!zoneList.data) {
      dispatch(ProductFilterActions.fetchZoneListAction());
    }
  }, [dispatch]);
  const isChecked = (currentKey: string) => {
    var isChecked = false;
    for (let key of Object.keys(props.selections.Zone.data))
      if (key !== currentKey)
        isChecked = isChecked || _.get(props.selections.Zone.data, key, null);
    return isChecked;
  };
  const onValueChange = (
    key: string,
    value: { id: string; label: string }[] | null
  ) => {
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.Zone]: {
          ...props.selections[PropertyFilterType.Zone],
          ...(isChecked(key) || value
            ? { isChecked: true }
            : { isChecked: false }),
          data: {
            ...props.selections[PropertyFilterType.Zone].data,
            [key]: value,
          },
        },
      })
    );
  };
  return (
    <Box
      style={{
        position: 'relative',
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={`zone`} defaultText="Zone" />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Select one'} />
      </Typography>
      {/* <SelectField
        label={{ translationKey: '', defaultText: ' ' }}
        options={PlotSizeOptions}
        onValueChange={onValueChange}
        field={'plot_land_size'}
        value={
          props.selections[PropertyFilterType.Zone].data.plot_land_size
        }
      /> */}
      <Autocomplete
        onChange={(event, item) => {
          onValueChange('zone', item ?? []);
        }}
        value={props.selections[PropertyFilterType.Zone].data.zone}
        options={
          zoneList?.data
            ? zoneList?.data.map((item) => ({
                id: item.zone ?? '',
                label: `${item.zone} - ${item.zone_description_name}` ?? '',
              }))
            : []
        }
        getOptionLabel={(item) => (item.label ? item.label : '')}
        getOptionSelected={(option, value) =>
          value === undefined || value === null || option.id === value.id
        }
        style={{
          marginTop: -16,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={''}
            margin="normal"
            variant="outlined"
          />
        )}
        renderOption={({ label }) => label}
        multiple
        disableCloseOnSelect
      />
      {zoneList.status === StateStatus.Pending ? (
        <Box
          style={{
            display: 'flex',
            position: 'absolute',
            right: '50%',
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
    </Box>
  );
};

export default TabZone;
